<template>
    <main class="report">
        <Steps :current-step="currentStep" />
        <transition-group name="fade">
            <Patient
                key="Patient"
                v-show="currentStep === 1"
                @next="nextStep($event)" />
            <Medical
                key="Medical"
                v-show="currentStep === 2"
                @back="prevStep($event)"
                @next="nextStep($event)" />
            <Findings
                key="Findings"
                v-show="currentStep === 3"
                @back="prevStep($event)"
                @next="nextStep($event)" />
            <Attachments
                key="Attachments"
                v-show="currentStep === 4"
                @back="prevStep($event)"
                @next="nextStep($event)"
                @updateStatus="uploadingProgress = $event"/>
            <Comments
                key="Comments"
                v-show="currentStep === 5"
                @back="prevStep($event)"
                @next="nextStep($event)"
                @updateMedCaseId="medicalCaseId = $event" />
            <Thanks
                v-show="currentStep === 6"
                :key="thanksKey"
                :medical-case-id="medicalCaseId"
                @back="prevStep($event)"/>
        </transition-group>
    </main>
</template>

<script>
import Steps from "@/components/report/Steps"
import Patient from "@/components/report/Patient"
import Medical from "@/components/report/Medical"
import Findings from "@/components/report/Findings"
import Attachments from "@/components/report/Attachments"
import Comments from "@/components/report/Comments"
import Thanks from "@/components/report/Thanks"

export default {
    name: "Report",
    components: {
        Steps,
        Patient,
        Medical,
        Findings,
        Attachments,
        Comments,
        Thanks
    },
    data() {
        return {
            currentStep: 1,
            thanksKey: 0,
            uploadingProgress: "",
            medicalCaseId: "",
        }
    },
    methods: {
        prevStep(prevStep) {
            this.currentStep = prevStep
        },
        nextStep(nextStep) {
            this.currentStep = nextStep
            if (nextStep === 6) {
                this.thanksKey += 1;
            }
        },
        uploadInProgress() {
            return this.uploadingProgress !== "" && this.uploadingProgress !== "completed";
        },
    },
    beforeRouteLeave(to, from, next) {
        if (this.uploadInProgress()) {
            if (!window.confirm("Przesyłanie plików nie zostało zakończone. Na pewno chcesz opuścić tę stronę?")) {
                return;
            }
        }
        next();
    },
};

</script>

<style lang="scss">
.report {
    flex: 1;
    &__title {
        text-align: center;
        text-transform: uppercase;
        letter-spacing: 1.6px;
        color: #4A4949;
    }
}
</style>
